/* OBJECTS */
import jQuery from 'jquery';
import Swiper from 'swiper';

var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');
var timerSearch;
var scrollTimer;
export default class WebApp {
  constructor () {}
  swiperInit = () => {
    //alert('d')
    var carousel_slider = new Swiper('.column-swiper', {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1078: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    });
  }
  tabs = () => {
    jQuery('.toggler>span').each(function (index) {
      jQuery(this).on('click', function (e) {
        e.preventDefault();
        var parent = jQuery(this).parent();
        var children = parent.find('> span');
        children.removeClass('active');
        jQuery(this).addClass('active');

        var anchor = jQuery(this).data('anchor');
        jQuery(this)
          .parents('.section')
          .find('div[data-toggler]')
          .addClass('hide');
        jQuery(this)
          .parents('.section')
          .find('div[data-toggler=' + anchor + ']')
          .removeClass('hide');

        jQuery(this)
          .parents('.section')
          .find('.toggler>span[data-anchor="' + anchor + '"]')
          .addClass('active');

        jQuery(this)
          .parents('.section')
          .find('.toggler>span[data-anchor="' + anchor + '"]')
          .prev()
          .removeClass('active');

        jQuery(this)
          .parents('.section')
          .find('.toggler>span[data-anchor="' + anchor + '"]')
          .next()
          .removeClass('active');
      });
    });

    jQuery('.tabs').each(function (index) {
      let tab = jQuery(this).find('.tab');
      tab.find('.title').on('click', function (e) {
        e.preventDefault();
        if (tab.hasClass('open')) {
          tab.removeClass('open');
        } else {
          tab.removeClass('open');
          jQuery(this).parent().toggleClass('open');
        }
      });
    });

    jQuery('.collapsable-text .info-button').on('click', function (e) {
      e.preventDefault();
      jQuery(this).parents('.collapsable-text').toggleClass('open');
    });
  }

  search_support = () => {
    async function search_ajax (text) {
      if (text.length < 3) {
        return;
      }
      return new Promise(function (resolve, reject) {
        jQuery.ajax({
          type: 'POST',
          url: '//' + window.location.hostname + '/wp-admin/admin-ajax.php',
          data: {
            term: text,
            type: 'search',
            action: 'ln_ajax_control' //this is the name of the AJAX method called in WordPress
          },
          success: function (result) {
            resolve(result);
          },
          error: function (err) {
            reject(err);
          }
        });
      });
    }
    if (jQuery('.search-bar-wrap').length > 0) {
      jQuery('body').on('click', '.do_search', function (e) {
        e.preventDefault();
        var wrap = jQuery(this).parents('.search-bar-wrap');
        var tags = wrap.find('.tags');
        var text = wrap.find('input[name="search"]').val();
        wrap.addClass('loading');
        try {
          search_ajax(text).then(
            function (value) {
              tags.html(value);
              wrap.removeClass('loading');
            },
            function (error) {
              console.log(error);
              wrap.removeClass('loading');
            }
          );
        } catch (e) {
          console.log(e);
          wrap.removeClass('loading');
        }
      });

      jQuery('input[name="search"]').on('input', function (event) {
        clearTimeout(timerSearch);
        var wrap = jQuery(this).parents('.search-bar-wrap');
        var tags = wrap.find('.tags');
        var input = jQuery(this);
        timerSearch = setTimeout(function () {
          wrap.addClass('loading');
          try {
            search_ajax(input.val()).then(
              function (value) {
                tags.html(value);
                wrap.removeClass('loading');
              },
              function (error) {
                console.log(error);
                wrap.removeClass('loading');
              }
            );
          } catch (e) {
            console.log(e);
            wrap.removeClass('loading');
          }
        }, 500);
      });
    }
  }
  sticky = () => {
    if (jQuery('.feature-table').length <= 0) {
      return;
    }
    var from_bot = jQuery('.feature-table-footer').offset().top;
    var from_top = jQuery('.feature-table').offset().top;
    var window_top = jQuery(window).scrollTop();
    var width = jQuery('.feature-table-header').width();
    if (window_top >= from_top && window_top <= from_bot - 80) {
      jQuery('.feature-table-header').data('from-top', from_top);

      jQuery('.feature-table-header').css('width', width);
      var header_height = jQuery('.feature-table-header').height();
      jQuery('.feature-table-header.stick')
        .next()
        .addClass('stick-pad')
        .css('padding-top', header_height);
      jQuery('.feature-table-header').addClass('stick');
    } else {
      jQuery('.stick-pad').removeAttr('style');
      jQuery('.feature-table-header').removeClass('stick');
      jQuery('.feature-table-header').removeAttr('style');
    }
  }
  masonry = () => {
    if (jQuery('.masonary-list').length > 0) {
      console.log('load masonry');
      var grid = document.querySelector('.masonary-list');
      var iso = new Isotope(grid, {
        itemSelector: '.solution',
        masonry: {
          columnWidth: '.grid-sizer',
          gutter: 24
        }
      });

      imagesLoaded('.masonary-list', function () {
        setTimeout(() => {
          iso.layout();
        }, 1000);
      });
    }
  }
  mobimg = () => {
    var width = jQuery(window).width();

    jQuery('[data-mobile-pic]').each(function (index) {
      var mobile_url = jQuery(this).data('mobile-pic');
      var default_url = jQuery(this).data('default-pic');
      if (width <= 767) {
        jQuery(this).css('background-image', 'url("' + mobile_url + '")');
      } else {
        jQuery(this).css('background-image', 'url("' + default_url + '")');
      }
    });
  }
  init = () => {
    var obj = this;
    this.search_support();
    this.tabs();
    this.swiperInit();
    this.mobimg();
    this.masonry();
    jQuery(window).on('resize', function (e) {
      obj.sticky();
      obj.mobimg();
    });
    jQuery(window).on('scroll', function (e) {
      obj.sticky();
    });
  }
}
